import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  DeviceIds,
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeatureNames,
  RoomChannelsEntityCommands,
  RoomChannelsEntityProperties,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-src-smart-climate-optimization',
  templateUrl: './src-smart-climate-optimization.component.html',
  styleUrl: './src-smart-climate-optimization.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSmartClimateOptimizationComponent {
  @Input() roomChannelsEntity: Feature<RoomChannelsEntityProperties, RoomChannelsEntityCommands>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  onChannelOptimizationToggle(change: boolean): void {
    const featureId = this.roomChannelsEntity.feature.split('.').at(-1);

    this.installationFeaturesStore.updateFeature(
      FeatureNames.roomsChannelsEntity(featureId),
      change,
      FeatureActionFields.active,
      '',
      FeatureCommands.setRoomInfluenceEnabled,
      null,
      DeviceIds.RoomControl
    );
  }
}
